export default __webpack_public_path__ + "static/media/Group 348.931e3bec.png";